var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"multitextbox"},[_c('div',{staticClass:"multi-title formtitle1"},[_vm._v(_vm._s(_vm.property.name)),(_vm.property.checked)?_c('span',{staticClass:"ischeck"},[_vm._v("*")]):_vm._e()]),_c('div',{staticClass:"multi-textarea"},[_vm._v("\n    请填写\n  ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }